<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useTokenSwitcher } from '@/shared/composables/useTokenSwitcher'
import LandingButtons from '@/landing/components/LandingButtons.vue'
import QualtricsSurvey from '@/components/common/QualtricsSurvey.vue'
import { useQualtricsStore } from '@/stores/qualtrics'

const { resetTokenMain } = useTokenSwitcher()
const qualtricsStore = useQualtricsStore()

onMounted(() => {
  resetTokenMain()
})

onUnmounted(() => {
  qualtricsStore.setShowQualtrics(false)
})
</script>

<template>
  <h1 class="text-[27px] font-bold text-center">Mi Claro Express</h1>
  <p class="mt-2 font-bold text-center">
    Elige la opción de tu preferencia <br />
    <span class="block text-xs"> (La navegación en el portal es gratuita) </span>
  </p>
  <LandingButtons />
  <QualtricsSurvey v-if="qualtricsStore.showQualtrics" />
</template>

<style scoped></style>
